import type { NextPage } from 'next';

import { ErrorFrame } from '@web/components/error-frame/error-frame';
import { HeroTitle } from '@web/components/hero-block/hero-title/hero-title';

import TemplateLayout from '@web/layouts/template/template';

import { useAuthenticatedCRMRequestConfig } from '@web/services/crm-api/hooks';
import { HeroAlignment } from '@web/services/umbraco/types/basic/Alignment';
import { BackgroundColor } from '@web/services/umbraco/types/basic/Color';
import { UmbracoErrorType } from '@web/services/umbraco/types/basic/ErrorTypes';
import { Link } from '@web/services/umbraco/types/basic/Link';
import { UmbracoPage } from '@web/services/umbraco/types/documents/UmbracoDocument';

import { ConsentsForm } from '@web/templates/user-consents-page/consents-form/consents-form';

export const userConsentsPageContentAlias = 'userConsentsPage' as const;

export type UserConsentsPageData = UmbracoPage<
	typeof userConsentsPageContentAlias,
	{
		hero: {
			title: string;
			subtitle?: string;
		};
		contactInfoPage: Link;
		privacyPolicyPage: Link;
	}
>;

const UserConsentsPageTemplate: NextPage<{ pageData: UserConsentsPageData }> = ({ pageData }) => {
	const { hero, contactInfoPage, privacyPolicyPage } = pageData.properties;
	const { isMember } = useAuthenticatedCRMRequestConfig();

	if (!isMember) {
		return <ErrorFrame errorType={UmbracoErrorType.Forbidden} />;
	}

	return (
		<TemplateLayout>
			{hero.title && (
				<HeroTitle
					title={hero.title}
					subtitle={hero.subtitle}
					alignment={HeroAlignment.Left}
					background={BackgroundColor.White}
				/>
			)}
			<ConsentsForm
				contactLink={contactInfoPage}
				privatePolicyLink={privacyPolicyPage}
			/>
		</TemplateLayout>
	);
};

export default UserConsentsPageTemplate;
